import { OrganizationTheme, SAND_ORGANIZATION_COLOR } from '../../theme/OrganizationTheme';
import OrganizationDescriptionEdit from './OrganizationDescriptionEdit';
import { OrganizationDescriptionShow } from './OrganizationDescriptionShow';
import styles from './organization-description.module.less';
import { Heading2 } from '@sb1/ffe-core-react';

const OrganizationDescription = ({ organization, title, editable }) => {
    return (
        <OrganizationTheme theme={SAND_ORGANIZATION_COLOR}>
            <div className={styles.container}>
                {title && (
                    <Heading2 lookLike={3} className={styles.descriptionTitle}>
                        {title}
                    </Heading2>
                )}

                {editable ? (
                    <OrganizationDescriptionEdit organization={organization} />
                ) : (
                    <OrganizationDescriptionShow organization={organization} />
                )}
            </div>
        </OrganizationTheme>
    );
};

export default OrganizationDescription;
